// CSV (semicolon/comma) and tab-separated spreadsheet clipboard text.
// Supports the compact format Nome;Preço;Categoria and the full BioGroup sheet:
// Nome | Quantidade/força | Unidade | Preço por frasco (R$) | Categoria | Quantidade disponível |
// Frascos por BOX ATACADO | Descrição | Foto (URL) | Disponível para clientes | Cadastro ativo
const boolCell=v=>!/^(nao|não|n|false|0)$/i.test(String(v||"SIM").trim());
const num=v=>{
  const raw=String(v??"").replace(/^R\$\s*/,"").replace(/\s/g,"");
  const normalized=raw.includes(",")?raw.replace(/\./g,"").replace(",","."):raw;
  const value=Number(normalized);return Number.isFinite(value)?value:NaN;
};
export function parseBulkProducts(text,categories){
  const source=String(text||"").replace(/^\uFEFF/,"").trim();
  if(!source)throw new Error("Cole a tabela ou escolha um arquivo CSV.");
  const first=source.split(/\r?\n/)[0];
  const delimiter=first.includes("\t")?"\t":first.includes(";")?";":",";
  const rows=[];let row=[],cell="",quoted=false;
  for(let i=0;i<source.length;i++){
    const c=source[i];
    if(c==='"'){if(quoted&&source[i+1]==='"'){cell+='"';i++;}else quoted=!quoted;}
    else if(!quoted&&(c===delimiter||c==="\n")){row.push(cell.trim());cell="";if(c==="\n"){if(row.some(Boolean))rows.push(row);row=[];}}
    else if(c!=="\r")cell+=c;
  }
  if(quoted)throw new Error("Há aspas sem fechamento na tabela.");
  row.push(cell.trim());if(row.some(Boolean))rows.push(row);
  if(!rows.length)throw new Error("Nenhum produto encontrado.");
  const header=rows[0].map(x=>String(x||"").trim().toLocaleLowerCase("pt-BR"));
  const full=/pre[cç]o.*frasco/i.test(rows[0].join(" "))||header.includes("frascos por box atacado")||header.includes("unidades por box/pack")||/pre[cç]o.*box/i.test(rows[0].join(" "));
  if(/^(nome|produto)$/i.test(rows[0]?.[0]))rows.shift();
  if(rows.length<1||rows.length>100)throw new Error("Importe de 1 a 100 produtos por vez.");
  const seen=new Set();
  return rows.map((r,i)=>{
    let name,price,category,quantity=100,pack_size=10,description="",photo_url="",available=true,active=true;
    if(full){
      if(r.length<7)throw new Error(`Linha ${i+1}: a planilha completa precisa das colunas do modelo BioGroup.`);
      name=String(r[0]||"").trim();price=num(r[3]);category=String(r[4]||"Outros").trim();
      quantity=Math.max(0,Math.trunc(num(r[5])));pack_size=10;if(r[6]!==""&&Number(r[6])!==10)throw new Error(`Linha ${i+1}: todo BOX deve possuir exatamente 10 frascos.`);
      description=String(r[7]||"").trim();photo_url=String(r[8]||"").trim();available=boolCell(r[9]);active=boolCell(r[10]);
    }else{
      if(r.length<2||r.length>3)throw new Error(`Linha ${i+1}: use Nome;Preço por frasco;Categoria.`);
      name=String(r[0]||"").trim();price=num(r[1]);category=String(r[2]||"Outros").trim();
    }
    const registered=categories.find(c=>c.toLocaleLowerCase("pt-BR")===category.toLocaleLowerCase("pt-BR"));
    if(!name||name.length>160||!Number.isFinite(price)||price<=0)throw new Error(`Linha ${i+1}: confira nome e preço por frasco.`);
    if(!Number.isFinite(quantity)||quantity<0)throw new Error(`Linha ${i+1}: quantidade disponível inválida.`);
    pack_size=10;
    if(!registered)throw new Error(`Linha ${i+1}: categoria inválida.`);
    const key=name.normalize("NFKC").replace(/\s+/g," ").toLocaleLowerCase("pt-BR");
    if(seen.has(key))throw new Error(`Linha ${i+1}: nome repetido na tabela.`);seen.add(key);
    return full?{name,price,category:registered,quantity,pack_size,description,photo_url,available,active}:{name,price,category:registered};
  });
}